export const ENVIRONMENT_MODE = process.env.REACT_APP_ENVIRONMENT;

export const URL_CONFIG = {
    API: {
        url: process.env.REACT_APP_API_URL
    },
    SOCKET: {
        url: process.env.REACT_APP_SOCKET_URL
    },
    // 2026-05-16 (B2B onboarding fix): enduser PWA の origin。事業者ログイン QR の URL 生成用。
    // REACT_APP_ENDUSER_URL 未設定時は本番 omikuji.jp を default。
    ENDUSER: {
        url: process.env.REACT_APP_ENDUSER_URL || 'https://omikuji.jp'
    }
};
